export const adaptPrograma = (tipoModuloData) => {
    const display = tipoModuloData?.abreviacion + " - " + tipoModuloData?.descripcion;
    return {
        id: tipoModuloData?.idTipoModulo,
        displayName: display,
        name: display
    }
}

export const adaptProgramaArray = (
    tipoModulos
) => {
    return structuredClone(tipoModulos)
        ?.map(tipoModulo => adaptPrograma(tipoModulo));
}